module.exports = __webpack_public_path__ + "static/media/Classic S VR.37fb5f8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Classic S VR.mp3
// module id = Se4l
// module chunks = 12